import axios from "axios";

export default {
  namespaced: true,
  state: {
    deposits: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    depositsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    CLEAR_DEPOSITS(state) {
      state.deposits = [];
    },
    SET_QUERY(state, payload) {
      state.query = Object.assign({}, payload);
    },
    RECEIVED_DEPOSITS(state, payload) {
      state.deposits = payload;
      state.isReceiving = false;
    },
    RECEIVED_DEPOSIT(state, payload) {
      let find = state.deposits.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { deposits: [payload, ...state.deposits] });
      }
      else {
        let index = state.deposits.findIndex(x => x._id === payload._id);
        state.deposits.splice(index, 1, payload);
      }
    },
    RECEIVING_DEPOSITS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_DEPOSIT(state) {
      state.isReceiving = true;
    },
    UPDATED_DEPOSIT(state, payload) {
      let index = state.deposits.findIndex(deposit => deposit._id === payload._id);
      state = Object.assign(state, {
        deposits: state.deposits.map((deposit, i) => {
          if (i === index) {
            return Object.assign({}, deposit, payload);
          }
          return deposit;
        }),
        isUpdating: false,
        depositsMessage: 'Deposits has been updating!',
      })
    },
    UPDATING_DEPOSIT(state) {
      state.isUpdating = true;
    },
    DELETED_DEPOSIT(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.deposits.findIndex(deposit => deposit._id === payload._id);
      console.log(indexToDelete);
      let deposits = [...state.deposits];
      deposits.splice(indexToDelete, 1);
      state = Object.assign(state, {
        deposits: [...deposits],
        isDeleting: false,
        idToDelete: null,
        depositsMessage: 'Deposit has been Deleted!',
      });
    },
    DELETING_DEPOSIT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteDepositRequest({dispatch}, payload) {
      dispatch("deletingDeposit", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/deposit/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteDeposit", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteDepositTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/dptransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertDepositRequest({dispatch}, payload) {
      try {
        dispatch("receivingDeposits");
        var token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/deposit';
        let data = payload;
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log('here2');
        let response = await axios({method: "post", url: url, headers: headers, data: data});
        await dispatch("receiveDeposit", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }

    },
    async insertDepositTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/dptransaction/" + payload.id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getDepositsRequest({dispatch}) {
      dispatch("receivingDeposits");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/deposits';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log('deposits', response.data)
        dispatch("receiveDeposits", response.data);
      })
    },
    async getDepositRequest({dispatch}, id) {
      dispatch("receivingDeposits");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/deposit/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receiveDeposit", response.data);
      return response.data;
    },
    async findDepositsRequest({dispatch}, payload) {
      try{
        dispatch("receivingDeposits");
        dispatch("setQuery", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/deposits';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveDeposits", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateDepositRequest({dispatch}, payload) {
      dispatch("updatingDeposit");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/deposit/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateDeposit", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateDepositTransaction({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/dptransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingDeposit", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    clearDeposits({commit}) {
      commit("CLEAR_DEPOSITS")
    },
    async setQuery({commit}, payload) {
      commit("SET_QUERY", payload);
    },
    receiveDeposits({commit}, payload) {
      commit("RECEIVED_DEPOSITS", payload)
    },
    receivingDeposits({commit}) {
      commit("RECEIVING_DEPOSITS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receiveDeposit({commit}, payload) {
      commit("RECEIVED_DEPOSIT", payload)
    },
    receivingDeposit({commit}) {
      commit("RECEIVING_DEPOSIT")
    },
    updateDeposit({commit}, payload) {
      commit("UPDATED_DEPOSIT", payload)
    },
    updatingDeposit({commit}) {
      commit("UPDATING_DEPOSIT")
    },
    deleteDeposit({commit}, payload) {
      commit("DELETED_DEPOSIT", payload)
    },
    deletingDeposit({commit}, payload) {
      commit("DELETING_DEPOSIT", payload)
    }
  },
};
